import React, { useState, useEffect, useCallback } from 'react';
import { Map, Marker, NavigationControl } from 'react-map-gl/mapbox';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import 'mapbox-gl/dist/mapbox-gl.css';

import { mapStyle } from '../../../../components/custom-map/constant';

import Pin from './Pin';

const initialViewState = {
  latitude: 45,
  longitude: -85,
  zoom: 4.5,
};

const MapLocation = ({ marker, setMarkerLocation }) => {
  const [viewport, setViewport] = useState(initialViewState);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const fallbackMarker = {
    latitude: initialViewState.latitude,
    longitude: initialViewState.longitude,
  };

  const markerCoords = marker?.latitude != null && marker?.longitude != null
    ? marker
    : fallbackMarker;

  useEffect(() => {
    if (marker?.latitude != null && marker?.longitude != null) {
      setViewport({
        ...viewport,
        zoom: 9,
        latitude: marker.latitude,
        longitude: marker.longitude,
      });
    }
  }, [marker]);

  const onMarkerDragEnd = useCallback((event) => {
    setMarkerLocation({
      longitude: event.lngLat[0],
      latitude: event.lngLat[1],
    });
  }, []);

  const onMapClick = useCallback((event) => {
    setMarkerLocation({
      longitude: event.lngLat[0],
      latitude: event.lngLat[1],
    });
  }, []);

  return (
    <div
      className="map-container"
      style={{
        width: isMobile ? '100%' : 475,
        height: isMobile ? 200 : 320,
      }}
    >
      <Map
        {...viewport}
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
        initialViewState={initialViewState}
        style={{ width: '100%', height: '100%' }}
        height="100%"
        maxZoom={20}
        maxPitch={0}
        dragRotate={false}
        touchRotate={false}
        onClick={isMobile ? undefined : onMapClick}
        onViewportChange={(viewport) => setViewport(viewport)}
        mapStyle={mapStyle}
      >
        <Marker
          longitude={markerCoords.longitude}
          latitude={markerCoords.latitude}
          anchor="bottom"
          draggable={!isMobile}
          onDragEnd={isMobile ? undefined : onMarkerDragEnd}
        >
          <Pin />
        </Marker>
        <NavigationControl
          style={{
            position: 'absolute',
            bottom: 50,
            left: 'calc(100% - 40px)',
          }}
        />
      </Map>
    </div>
  );
};

MapLocation.propTypes = {
  marker: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  setMarkerLocation: PropTypes.func,
};

MapLocation.defaultProps = {
  marker: {
    latitude: 45,
    longitude: -85,
  },
  setMarkerLocation: () => {},
};

export default MapLocation;
